import { AccountVerifiedGuard } from '@pages/auth/guard/account-verified.guard';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SessionAndEmailGuard extends AccountVerifiedGuard {

  appoGuards = [
    this.sessionGuard,
    this.emailVerifiedGuard,
  ];

  canActivate(): Observable<boolean> {
    console.log('Running SessionAndEmailGuard');
    return super.canActivate();
  }

}
